export const SIGN_IN_REJECTED = "SIGN_IN_REJECTED";
export const FETCH_TOKEN_REJECTED = "FETCH_TOKEN_REJECTED";
export const FETCH_TOKEN_FULFILLED = "FETCH_TOKEN_FULFILLED";


// WEBPACK FOOTER //
// ./src/constants/signin.js